import { NavLink } from "react-router-dom";
import { Mic, LineChart, BookOpen, Zap, CreditCard } from "lucide-react";

const tabs = [
  { to: "/app", icon: Mic, label: "Studio", end: true, testid: "mobile-tab-studio" },
  { to: "/app/insights", icon: LineChart, label: "Insights", testid: "mobile-tab-insights" },
  { to: "/app/dictionary", icon: BookOpen, label: "Words", testid: "mobile-tab-dictionary" },
  { to: "/app/snippets", icon: Zap, label: "Snippets", testid: "mobile-tab-snippets" },
  { to: "/app/billing", icon: CreditCard, label: "Billing", testid: "mobile-tab-billing" },
];

export default function MobileBottomNav() {
  return (
    <nav
      data-testid="mobile-bottom-nav"
      className="lg:hidden fixed bottom-0 inset-x-0 z-40 bg-white border-t border-brand-borderc shadow-[0_-6px_24px_-12px_rgba(15,23,42,0.18)] pb-[env(safe-area-inset-bottom)]"
    >
      <ul className="grid grid-cols-5">
        {tabs.map((t) => (
          <li key={t.to}>
            <NavLink
              to={t.to}
              end={t.end}
              data-testid={t.testid}
              className={({ isActive }) =>
                `flex flex-col items-center justify-center gap-0.5 py-2.5 text-[10px] font-medium transition select-none ${
                  isActive ? "text-brand-purple" : "text-brand-muted hover:text-brand-text"
                }`
              }
            >
              <t.icon className="w-5 h-5" />
              <span>{t.label}</span>
            </NavLink>
          </li>
        ))}
      </ul>
    </nav>
  );
}
